import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationDropd from "../../screens/admin/dashboard/notificationdropd/NotificationDropd";
import "../../assets/css/layout/admin/AdminHeader.css";

const AdminHeader = ({
  pageTitle,
  breadcrumb,
  notificationCount,
  adminName,
  onToggleSidebar,
  onNotificationChange, 
}) => {

  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const initials = adminName
    ? adminName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "AD";

  return (
    <header className="sgc-header">

      {/* LEFT */}
      <div className="d-flex align-items-center gap-3">

        <div
          className="sgc-header-toggle"
          onClick={onToggleSidebar}
        >
          ☰
        </div>

        <div>
          <p className="sgc-header-page-title">
            {pageTitle || "Dashboard"}
          </p>

          {breadcrumb && (
            <p className="sgc-header-breadcrumb">
              {breadcrumb}
            </p>
          )}
        </div>

      </div>

      {/* RIGHT */}
      <div className="sgc-header-right">

        {/* Notification */}
        <div className="sgc-header-notification-wrap">

          <div
            className="sgc-header-notification"
            onClick={() => setShowDropdown((prev) => !prev)}
          >
            🔔

            {notificationCount > 0 && (
              <span className="sgc-header-notification-badge">
                {notificationCount}
              </span>
            )}
          </div>

          {/* Dropdown */}
          {showDropdown && (
  <NotificationDropd
    onClose={() => setShowDropdown(false)}
    onNotificationChange={onNotificationChange}
  />
)}
          {/* {showDropdown && 
            <NotificationDropd
              onClose={() => setShowDropdown(false)}
            />
          )}*/}

        </div> 

        {/* Profile */}
        <div
          className="sgc-header-user"
          onClick={() => navigate("/admin/profile")}
        >
          <div className="sgc-header-avatar">
            {initials}
          </div>

          <span>{adminName || "Admin"}</span>
        </div>

      </div>
    </header>
  );
};

export default AdminHeader;